/**
 * /forgot-password → /forgot. Nothing links here, but people type it
 * (and other products use it), so land them on the real reset page
 * instead of a 404 (stability check 2026-10-20).
 *
 * `redirect({ to })` with no `search` / `hash` carries nothing over
 * (router-core buildLocation: omitted search → {}, omitted hash →
 * dropped), so a stray `?email=` or token never echoes onto /forgot.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/forgot-password")({
  beforeLoad: () => {
    throw redirect({ to: "/forgot" });
  },
});
